import { DatetimeboxComponent } from './components/basic/datetimebox/datetimebox.component';
import { DatetimeboxDateDirective } from './directives/datetimebox-date.directive';
import { DatetimeboxDatetimeDirective } from './directives/datetimebox-datetime.directive';
import { DatetimeboxTimeDirective } from './directives/datetimebox-time.directive';
import { DecoratorDirective } from './directives/decorator.directive';

// Import this barrel via a relative path to avoid Angular NG3004.

export const Datetimebox = [
  DatetimeboxComponent,
  DatetimeboxDatetimeDirective,
  DatetimeboxDateDirective,
  DatetimeboxTimeDirective,
  DecoratorDirective
];
